export default __webpack_public_path__ + "static/soundWave-d6b4ba79539b2d9fb00169a07c86f91b.png";